import { DataTableColumn } from "../../../shared/components/data-table/DataTableColumn.model";
import { Currency } from "../../currencies/models/Currency";
import { Property } from "../../properties/models/Property";
import { VerificationPackage } from "../../verification-packages/models/VerificationPackage";

export interface Reservation {
    id: number;
    reservation_id: number;
    reservation_reference_id: string;
    reference_id: string;
    booking_date: string;
    arrival_date: string;
    departure_date: string;
    insurance_cost: number;
    insurance_refund_amount: number;
    insurance_refunded: boolean;
    number_of_guests: number;
    number_of_nights: number;
    reservation_cost: number;
    reservation_type?: any;
    status: any;
    reservation_currency_id: number;
    updated_insurance_cost: number;
    exclude_from_invoice: any;
    verification_cost: number;
    updated_verification_cost: number;
    verification_paid: any;
    verification_package?: VerificationPackage[];
    status_id: number;
    status_history: ReservationStatusEntry[];
    claim_token: string;
    claim_count: number;
    score: number;
    rating: string;
    property_id?: number;
    claim_id?: number;
    property: Property;
    organization_id: number | string;
    reservation_currency: Currency;
    for_guest_verification: number;
    for_reservation: number;
    selected_policies: ReservationSelectedPolicy[];
    reservation_guests: ReservationGuests[];
    guests: ReservationGuest[];
    created_date?: string;
    updated_date?: string;
}

export interface ReservationGuests {
    guest?: ReservationGuest;
    first_name?: string;
    middle_name?: string;
    last_name?: string;
    email?: string;
    phone_number?: string;
    birth_date?: Date;
        address?: {
        address_line_1?: string;
        address_line_2?: string;
        city?: string;
        state?: string;
        postal_code?: string;
        country_id?: number;
        country_name?: string;
    },
    verification_cost?: number;
}

export interface ReservationGuest {
    guest_id: number;
    first_name: string;
    middle_name?: string;
    last_name: string;
    email?: string;
    phone_number?: string;
    birth_date?: Date;
    relationship?: string;
    ssn?: number;
    verification_cost?: number;
    address?: {
        address_line_1: string;
        address_line_2: string;
        city: string;
        state: string;
        postal_code: string;
        country_id: number;
        country_name: string;
    },
    selected_verification_package?: number;
    verification_package?: VerificationPackage;
}

//TODO: Move this into the guests step class where it's used
export const ReservationGuestDisplayedColumns: DataTableColumn[] = [
    { column: 'name', display: 'Name' },
    { column: 'address', display: 'Address' },
    { column: 'email', display: 'Email' },
    { column: 'phone_number', display: 'Phone' },
    { column: 'verification_package', display: 'Verification Package' },
    { column: 'verification_cost', display: 'Verification Price' },
    { column: 'action', display: '' }
];

export interface ReservationStatusEntry {
    id: number;
    reservation_id: number;
    status_id: number;
    status_display: string;
    status_date: string;
}

export interface ReservationSelectedPolicy {
    id: number;
    reservation_id: number;
    insurance_policy_id: number;
    policy_property_price_id: number;
    policy_organization_price_id: number;
    price: number;
    extra_night_price: number;
    currency_id: number;
    deductible: number;
    pricing_model_id: number;
    number_of_nights_from: number;
    number_of_nights_to: number;
    policy_price_id: number;
    max_nights: any;
    adjusted_number_of_nights: any;
    extra_nights: any;
    insurance_cost: number;
    policy: ReservationPolicy;
    currency: Currency;
    pricing_model: ReservationPolicyPricingModel;
}

export interface ReservationPolicy {
    id: number;
    name: string;
    range_guests_from: any;
    range_guests_to: any;
    damage_coverage: number;
    liability_coverage: number;
    dwelling_coverage: number;
    all_countries: number;
    range_reservation_price_from: any;
    range_reservation_price_to: any;
    range_no_of_bedrooms_from: any;
    range_no_of_bedrooms_to: any;
    currency_id: number;
    status_id: number;
    account_id: number;
    created_date: string;
    description: string;
    note: string;
}

export interface ReservationPolicyPricingModel {
    id: number;
    code: string;
    display_text: string;
    display_order: string;
    is_active: number;
}

export interface Traveler {
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    birthDate: Date | undefined;
    streetAddress: string | undefined;
    city: string | undefined;
    state: string | undefined;
    postalCode: string | undefined;
    country?: string;
    countryId?: number;
}

export interface GoReadyPolicyManualOrderDTO {
    reservationId?: number | null;
    reservationReferenceId: string;
    organizationId: string;
    arrivalDate?: Date;
    departureDate?: Date;
    initialDepositDate?: Date;
    stateOfResidence: string;
    numberOfTravelers: number;
    tripCost: number;
    destinations: string[];
    primaryInsured: Traveler;
}

export interface PropertyReferenceIds {
    referenceIds: string[];
}

export const PropertyReservationsColumns: DataTableColumn[] = [
    { column: 'reservationId', display: 'Safely Res. ID' },
    { column: 'referenceId', display: 'Reservation ID' },
    { column: 'organizationId', display: 'Organization ID' },
    { column: 'organizationName', display: 'Organization Name' },
    { column: 'propertyName', display: 'Property Name' },
    { column: 'dates', display: 'Reservation Dates', renderHtml: true },
    { column: 'bookingDate', display: 'Booking Date' },
    { column: 'fullName', display: 'Guest' },
    { column: 'pillStatus', display: 'Status' },
    { column: 'action', display: '' }
]